import React from 'react'

export function User() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24.5" height="30.625" viewBox="0 0 24.5 30.625"><path d="M14.615,17A7.5,7.5,0,1,0,7.077,9.5,7.519,7.519,0,0,0,14.615,17Z" transform="translate(-2.365 -2)"/><path d="M20.176,13.837H12.324A8.358,8.358,0,0,0,4,22.118a2.648,2.648,0,0,0,1.413,2.5c1.413.781,4.554,1.719,10.837,1.719s9.423-.937,10.837-1.719a2.956,2.956,0,0,0,1.413-2.5A8.257,8.257,0,0,0,20.176,13.837Z" transform="translate(-4 4.288)" opacity="0.37"/></svg>
  )
}
